import React from 'react'
import { formatHour } from '../../../helpers/utils'
import { createReportDetailsTab } from './createReportDetailsTab'

const HEADERS = [
  { label: 'CÓDIGO', description: 'Número de identificación del usuario' },
  { label: 'USUARIO', description: 'Nombre del usuario' },
  { label: 'ÚLTIMA ACTIVIDAD', description: 'Hora de última actividad registrada' },
  { label: 'VISITAS REALIZADAS', description: 'Cantidad total de visitas registradas' },
  { label: 'VISITAS FUERA DE RUTA', description: 'Visitas que no estaban asignadas' },
  { label: 'EFECTIVIDAD', description: 'Porcentaje de visitas efectivas sobre las realizadas' },
  {
    label: 'ACTIVIDADES DENTRO DE GEOCERCA',
    description: 'Actividades dentro de la zona permitida'
  },
  {
    label: 'TAREAS EN SITIO',
    description: 'Progreso actual: tareas realizadas vs tareas restantes'
  }
]

function renderRow(model) {
  return (
    <>
      <td>{model.user_uid}</td>
      <td>{model.user_name}</td>
      <td className="text-center">{formatHour(model.pos_task_activity_last_visit)}</td>
      <td className="text-center">
        {model.total_visited_clients}/{model.all_executed_clients}
      </td>
      <td className="text-center">{model.out_of_route_clients}</td>
      <td className="text-center">{model.pos_task_activity_percent_effectiveness}%</td>
      <td className="text-center">
        {model.pos_task_activity_location_effective_count}/
        {model.pos_task_activity_location_available_count}
      </td>
      <td className="text-center">
        {model.pos_task_activity_done_task_codes_count}/
        {model.pos_task_activity_total_clients_count}
      </td>
    </>
  )
}

export default createReportDetailsTab({
  displayName: 'ReportPosTab',
  headers: HEADERS,
  renderRow
})
